
import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";


const BranchReportList = () => {
  const [report, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState("this_month");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [metric, setMetric] = useState("");
  const [limit, setLimit] = useState("");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);
  // console.log("this is all the perm", permissions);

  const navigate = useNavigate();

  //axios api encryption call
  const axios = AxiosApiCall();


  const fetchTopBranchReport = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }

      const payload = {
        period,
        metric: metric || "transactions", // default fallback
        limit: limit || 10,               // default fallback
      };

      if (period === "custom") {
        if (startDate) payload.start_date = startDate;
        if (endDate) payload.end_date = endDate;
      }
      const response = await axios.post(ApiServices.getTopBranchReport, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data;
      // console.log("this is all product stock list", data);

      if (status === 200) {
        // setReportData(data.slice().reverse());
        setReportData(data.branches);
        toast.success(message, { toastId: "product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchTopBranchReport();
  }, []);


  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchTopBranchReport();
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleClearDateFilter = () => {
    setStartDate("");
    setEndDate("");
    setMetric("");
    setLimit("");
    fetchTopBranchReport();
  };

  const columns = [
    {
      name: "Branch Name",
      selector: (row) => (row.branch_name ? row.branch_name.toUpperCase() : ""),
      sortable: true,
      width: "300px",
    },
    {
      name: "Total Sales",
      selector: (row) => (row.total_sales ? CurrencyFormatter(row.total_sales) : "0.00"),
      sortable: true,
      width: "200px",
    },
    {
      name: "Qty Sales",
      selector: (row) => (row.total_volume ? row.total_volume : "0"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Total Transactions",
      selector: (row) => (row.total_transactions ? row.total_transactions : "0"),
      sortable: true,
      width: "180px",
    },
    {
      name: "Wallets Ballance",
      selector: (row) => (row.wallet_balance ? CurrencyFormatter(row.wallet_balance) : "0"),
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.is_activated ? row.is_activated.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => (
        <span className={row.is_activated === true ? "text-dash" : "text-dash3"}>
          {row.is_activated ? "ACTIVE" : "NON ACTIVE"}
        </span>
      ),
      width: "100px",
    },


  ];

  const filteredItems = report.filter((item) =>
    Object.keys(item).some((key) =>
      item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
    )
  );

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Report
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">Top Branch</p>
                </li>
              </ol>
            </nav>
          </section>
          <form
            onSubmit={handleFilterSubmit}
            className="flex flex-wrap items-end gap-4 px-0 pt-4 mb-4"
          >
            <div>
              <label className="block text-sm text-gray-700 mb-1 ">Period</label>
              <select
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                className="border border-grey3 p-2 rounded-md w-48 py-3"
              >
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="this_week">This Week</option>
                <option value="last_week">Last Week</option>
                <option value="this_month">This Month</option>
                <option value="last_month">Last Month</option>
                <option value="custom">Custom</option>
              </select>
            </div>

            {period === "custom" && (
              <>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">
                    Start Date
                  </label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="border border-grey3 p-2 rounded-md"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="border border-grey3 p-2 rounded-md"
                    required
                  />
                </div>
              </>
            )}
            <div>
              <label className="block text-sm text-gray-700 mb-1">Metric</label>
              <select
                value={metric}
                onChange={(e) => setMetric(e.target.value)}
                className="border border-grey3 p-2 rounded-md w-48 py-3"
              >
                <option value="transactions">Transactions</option>
                <option value="sales">Sales</option>
                <option value="volume">Volume</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-1">Limit</label>
              <input
                type="number"
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
                className="border border-grey3 p-2 rounded-md w-48 py-2"
                min={1}
                max={100}
              />
            </div>

            <button
              type="submit"
              className="bg-darkGreen2 hover:bg-darkGreen2 text-lGrey px-4 py-2 rounded-md"
            >
              Apply Filter
            </button>
            <button
              onClick={handleClearDateFilter}
              className="px-4 py-2 bg-orange1 text-lGrey rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Clear
            </button>
          </form>
          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>

          </div>
          {loading ? (
            <Spinner />
          ) : (
            <DataTable
              columns={columns}
              data={filteredItems}
              pagination
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No Branch Report found</div>}
            // expandableRows
            // expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default BranchReportList;






